// NO EDITAR A MANO
export type Langs = "de-AT" | "de-DE" | "en-CA" | "en-GB" | "en-US" | "es-AR" | "es-BO" | "es-CL" | "es-CR" | "es-DO" | "es-EC" | "es-ES" | "es-HN" | "es-MX" | "es-PA" | "es-PE" | "es-PY" | "es-UY" | "es-VE" | "fr-FR" | "it-IT" | "nl-NL" | "pt-BR" | "pt-PT" | "ru-RU";

export const SOPORTADOS: string[] = ["de-AT", "de-DE", "en-CA", "en-GB", "en-US", "es-AR", "es-BO", "es-CL", "es-CR", "es-DO", "es-EC", "es-ES", "es-HN", "es-MX", "es-PA", "es-PE", "es-PY", "es-UY", "es-VE", "fr-FR", "it-IT", "nl-NL", "pt-BR", "pt-PT", "ru-RU"];

export function check(lang: string, defecto: string = "en-US", mapping: Record<string, string> = {}): Langs {
    if (SOPORTADOS.indexOf(lang)<0) {
        lang = defecto;
    }
    if (mapping[lang]!=undefined) {
        lang = mapping[lang];
    }

    return lang as Langs;
}

export const checkClean = (lang: string, defecto?: string, mapping: Record<string, string> = {}): string => check(lang, defecto, mapping).replace("-", "");
